module.exports = __webpack_public_path__ + "static/media/55_000026.cc9afa25.jpg";